import apiConfig from "constants/apiConfig";
import { MembershipCheckoutData, SubscriptionFrequencies } from "types/membership";
import axiosClient from "utils/axiosClient";

export const fetchMembership = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_MEMBERSHIP.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const fetchSubscriptionPlans = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SUBSCRIPTION_PLANS.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const startTrialPlan = async (agencyId: string, planId: string | number) => {
    const response = await axiosClient.post(apiConfig.START_TRIAL_PLAN.url.replace('<agencyId>', agencyId), { plan_id: planId, frequency_slug: 'weekly' });
    return response.data;
}



export const startMembership = async (agencyId: string, frequency_slug: SubscriptionFrequencies, plan_id: number): Promise<MembershipCheckoutData> => {
    const response = await axiosClient.post(apiConfig.START_MEMBERSHIP.url.replace('<agencyId>', agencyId), { frequency_slug, plan_id });
    return response.data;
}

export const changeMembership = async (agencyId: string, frequency_slug: SubscriptionFrequencies,
    plan_id: number,
    active_plan_uuid: string
): Promise<MembershipCheckoutData> => {
    const response = await axiosClient.put(apiConfig.CHANGE_MEMBERSHIP.url.replace('<activePlanUUID>', active_plan_uuid).replace('<agencyId>', agencyId), { frequency_slug, plan_id })
    return response.data;
}

export const verifyMembershipPayment = async (paymentUUID: string, razorpay_payment_id: string, razorpay_signature: string): Promise<boolean> => {
    const response = await axiosClient.post(apiConfig.VERIFY_MEMBERSHIP_PAYMENT.url.replace('<paymentUUID>', paymentUUID), { razorpay_payment_id, razorpay_signature });
    return response.data.status;
}

export const cancelMembership = async (agencyId: string) => {
    const response = await axiosClient.post(apiConfig.CANCEL_MEMBERSHIP.url.replace('<agencyId>', agencyId));
    return response.data;
}